import QueryString from 'qs';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useQueryParams<T>() {
  const location = useLocation();
  return useMemo<T>(() => QueryString.parse(location.search, { ignoreQueryPrefix: true }) as T, [location.search]);
}
